import React, { forwardRef, useId, useState, InputHTMLAttributes } from "react";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";
import "./form-inputs.style.scss";

interface InputTextProps extends InputHTMLAttributes<HTMLInputElement> {
	label?: string;
	icon?: React.ReactNode;
	error?: string;
	securetext?: boolean;
	hasClearField?: boolean;
	onClearField?: () => void;
	containerClassName?: string;
	inputClassName?: string;
}

const InputText = forwardRef<HTMLInputElement, InputTextProps>(
	(
		{
			type = "text",
			label,
			icon,
			error,
			securetext = false,
			hasClearField = false,
			onClearField,
			disabled = false,
			className = "",
			containerClassName = "",
			inputClassName,
			...rest
		},
		ref,
	) => {
		const [passwordVisible, setPasswordVisible] = useState(false);
		const generatedId = useId();
		const inputId = rest.id ?? generatedId;

		const isPassword = type === "password" || securetext;
		const resolvedType = isPassword
			? passwordVisible
				? "text"
				: "password"
			: type;

		return (
			<div className={`input-item${className ? ` ${className}` : ""}`}>
				{label && (
					<label htmlFor={inputId} className="input-label">
						{label}
					</label>
				)}
				<div
					className={`input-box-wrapper${error ? " error" : ""}${disabled ? " disabled" : ""}${containerClassName ? ` ${containerClassName}` : ""}`}
				>
					{icon && <span className="input-icon">{icon}</span>}
					<input
						ref={ref}
						id={inputId}
						type={resolvedType}
						disabled={disabled}
						autoComplete="off"
						onWheel={
							type === "number" ? (e) => e.currentTarget.blur() : undefined
						}
						className={inputClassName}
						{...rest}
					/>
					{isPassword && (
						<button
							type="button"
							className="input-action-btn"
							onClick={() => setPasswordVisible((v) => !v)}
						>
							{passwordVisible ? <FaRegEye /> : <FaRegEyeSlash />}
						</button>
					)}
					{hasClearField && (
						<button
							type="button"
							className="input-action-btn"
							onClick={onClearField}
						>
							<FaXmark />
						</button>
					)}
				</div>
				{error && <div className="validation-error">{error}</div>}
			</div>
		);
	},
);

InputText.displayName = "InputText";
export default InputText;
